import { render, staticRenderFns } from "./activitygroupdetails.vue?vue&type=template&id=0e6c971b&scoped=true&"
import script from "./activitygroupdetails.vue?vue&type=script&lang=js&"
export * from "./activitygroupdetails.vue?vue&type=script&lang=js&"
import style0 from "./activitygroupdetails.vue?vue&type=style&index=0&id=0e6c971b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c971b",
  null
  
)

export default component.exports